import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'

const SlackOAuthServiceContext = createContext(undefined)

const SlackOAuthServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={SlackOAuthServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        createAccessToken: async (payload) => {
          const {data} = await axios.post(`/api/v1/slack/organizations/slack_app_install_access_tokens`, payload)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

SlackOAuthServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useSlackOAuthService = () => {
  const context = useContext(SlackOAuthServiceContext)
  if (context === undefined) {
    throw new Error('SlackOAuthServiceContext was not provided. Make sure your component is a child of the SlackOAuthServiceProvider.')
  }
  return context
}

export {SlackOAuthServiceProvider, useSlackOAuthService}
